
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ChildComponentMixin } from '@/mixins'
import AppCheckbox from '@/components/AppCheckbox.vue'
import AppContextMenu from '@/components/AppContextMenu.vue'
import { integrationModuleEntity } from '@/models/models'

@Component
export default class PartnersTableRow extends ChildComponentMixin {
    @Prop() private row!: PartnerEntity

    get isStatusFinished() {
        return this.row.status === 'FINISHED'
    }

    get prettyStatus() {
        return this.isStatusFinished ? 'Finalizado' : 'Iniciado'
    }

    get isApikeyStatusInactive() {
        return this.row.apikey && this.row.apikey.status === 'INACTIVE'
    }

    get prettyApikeyStatus() {
        return this.isApikeyStatusInactive ? 'Inativo' : 'Ativo'
    }

    @Emit('click')
    public onClickRow(e: Event) {
        e.stopPropagation()

        return e
    }
}
